"use client";
const breakpointMobile = "480px";
const breakpointTablet = "768px";
const breakpointDesktop = "1024px";
export {
  breakpointDesktop,
  breakpointMobile,
  breakpointTablet
};
